import { render } from "./DialogOnetimeCodeFails.vue?vue&type=template&id=d8aa5520"
import script from "./DialogOnetimeCodeFails.vue?vue&type=script&lang=js"
export * from "./DialogOnetimeCodeFails.vue?vue&type=script&lang=js"
script.render = render

export default script